import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../lib/auth.js';
import { Spinner } from '../components/ui/index.js';

// 어드민 전용 라우트 가드
export function AdminRoute() {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (user?.role !== 'ADMIN') {
    return <Navigate to="/dashboard" />;
  }

  return <Outlet />;
}
